import { useRef, useState } from "react";
import { getFormulaInfo, getLabelFromFieldName } from "../utils/formulas";
import { ClickAwayListener, IconButton, Paper, Popper } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

export const FormulaTooltip = ({ className, fieldName, quoteDetails }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const iconRef = useRef(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const result = getFormulaInfo(fieldName, quoteDetails);
    const isNoteNeeded = result?.formula?.includes("<sup>1</sup>");

    return (
        <>
            {quoteDetails && <ClickAwayListener onClickAway={handleClose}>
                <div>
                    <IconButton ref={iconRef} onClick={handleClick}>
                        <InfoIcon className="info-icon" />
                    </IconButton>

                    <Popper open={open} anchorEl={anchorEl} placement="bottom-start">
                        <Paper className={className}>
                            <div>
                                <p><strong>{getLabelFromFieldName(fieldName)}</strong></p>
                                <p dangerouslySetInnerHTML={{ __html: `Formula: ${result.formula}` }} />
                                <p dangerouslySetInnerHTML={{ __html: `Calculation: ${result.calculation}` }} />
                                {isNoteNeeded && <p className="text-red"><sup>1</sup>This value is set in app settings of LEAGO</p>}
                            </div>
                        </Paper>
                    </Popper>
                </div>
            </ClickAwayListener>}
        </>
    );
};
